// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3-pRv","title":"Images90_title__12Yux","images":"Images90_images__2iZhz"};